export default "__VITE_ASSET__24Fkwfwy__"